import { useEffect, useState } from 'react'
import allQuestions from './questions.json'

export default function App() {
	const [shownQuestions, setShownQuestions] = useState<string[]>([])
	const [currentQuestion, setCurrentQuestion] = useState<string | null>(null)
	const [favorites, setFavorites] = useState<string[]>([])
	const [previousQuestions, setPreviousQuestions] = useState<string[]>([])
	const [mode, setMode] = useState<'all' | 'favorites'>('all')
	const [progress, setProgress] = useState(0)

	useEffect(() => {
		const saved = localStorage.getItem('favorites')
		if (saved) setFavorites(JSON.parse(saved))
	}, [])

	useEffect(() => {
		localStorage.setItem('favorites', JSON.stringify(favorites))
	}, [favorites])

	useEffect(() => {
		setProgress(Math.round((shownQuestions.length / allQuestions.length) * 100))
	}, [shownQuestions])

	const getNextQuestion = () => {
		const source = mode === 'favorites' ? favorites : allQuestions
		const remaining = source.filter(q => !shownQuestions.includes(q))
		if (remaining.length === 0) {
			setCurrentQuestion('Все вопросы показаны 🎉')
			return
		}
		const random = remaining[Math.floor(Math.random() * remaining.length)]
		if (currentQuestion) setPreviousQuestions([...previousQuestions, currentQuestion])
		setCurrentQuestion(random)
		setShownQuestions([...shownQuestions, random])
	}

	const addToFavorites = () => {
		if (currentQuestion && !favorites.includes(currentQuestion)) {
			setFavorites([...favorites, currentQuestion])
		}
	}

	const removeFromFavorites = (q: string) => {
		setFavorites(favorites.filter(f => f !== q))
	}

	const goBack = () => {
		if (previousQuestions.length === 0) return

		const last = previousQuestions[previousQuestions.length - 1]

		setPreviousQuestions(prev => prev.slice(0, -1))
		setShownQuestions(prev => prev.slice(0, -1))
		setCurrentQuestion(last)
	}

	const toggleMode = () => {
		setShownQuestions([])
		setPreviousQuestions([])
		setCurrentQuestion(null)
		setMode(mode === 'all' ? 'favorites' : 'all')
	}

	return (
		<div
			style={{
				fontFamily: 'system-ui, sans-serif',
				maxWidth: '600px',
				margin: 'auto',
				padding: '24px',
				color: '#222',
				lineHeight: 1.6,
			}}>
			<h1
				style={{
					fontSize: '28px',
					fontWeight: 600,
					marginBottom: '24px',
					textAlign: 'center',
				}}>
				Что-то между
			</h1>

			{!currentQuestion ? (
				<div style={{ textAlign: 'center', marginTop: '40px' }}>
					<DescriptionBlock />

					<button
						onClick={getNextQuestion}
						style={{
							fontSize: '18px',
							padding: '12px 24px',
							borderRadius: '8px',
							border: 'none',
							backgroundColor: '#000',
							color: '#fff',
							cursor: 'pointer',
							transition: 'background 0.2s',
							marginTop: '24px',
							minWidth: '260px',
						}}
						onMouseOver={e => (e.currentTarget.style.backgroundColor = '#333')}
						onMouseOut={e => (e.currentTarget.style.backgroundColor = '#000')}>
						🚀 Старт
					</button>
				</div>
			) : (
				<>
					<div
						style={{
							backgroundColor: '#f4f4f4',
							padding: '24px',
							borderRadius: '12px',
							boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
							transition: 'all 0.2s',
						}}>
						<p style={{ minHeight: '80px', fontSize: '18px', marginBottom: '16px' }}>
							{currentQuestion}
						</p>
						<p style={{ fontSize: '14px', color: '#666' }}>Прогресс: {progress}%</p>

						<div
							style={{
								display: 'flex',
								gap: '12px',
								flexWrap: 'wrap',
								marginTop: '16px',
							}}>
							<button onClick={getNextQuestion} className='button'>
								Следующий вопрос
							</button>
							<button onClick={goBack} className='button'>
								Назад
							</button>
							{currentQuestion !== 'Все вопросы показаны 🎉' && (
								<button onClick={addToFavorites} className='button'>
									В избранное
								</button>
							)}
						</div>
					</div>

					{favorites.length > 0 && (
						<div style={{ marginTop: '32px' }}>
							<h2 style={{ fontSize: '20px', marginBottom: '12px' }}>⭐ Избранное</h2>
							<ul style={{ listStyle: 'disc', paddingLeft: '20px', color: '#444' }}>
								{favorites.map((q, i) => (
									<li key={i} style={{ marginBottom: '8px' }}>
										{q}
										<button
											onClick={() => removeFromFavorites(q)}
											style={{
												marginLeft: '12px',
												fontSize: '13px',
												color: '#000',
												backgroundColor: '#f3f4f6',
												border: '1px solid #dcdcdc',
												cursor: 'pointer',
												padding: '4px 8px',
												borderRadius: '6px',
												transition: 'all 0.2s ease',
											}}
											onMouseOver={e => {
												e.currentTarget.style.backgroundColor = '#ffe5e5'
												e.currentTarget.style.color = '#d72828'
												e.currentTarget.style.borderColor = '#d72828'
											}}
											onMouseOut={e => {
												e.currentTarget.style.backgroundColor = '#f3f4f6'
												e.currentTarget.style.color = '#000'
												e.currentTarget.style.borderColor = '#dcdcdc'
											}}>
											удалить
										</button>
									</li>
								))}
							</ul>
						</div>
					)}
				</>
			)}

			<p
				style={{
					marginTop: '32px',
					fontSize: '14px',
					color: '#666',
					textAlign: 'center',
				}}>
				Проект создан с любовью. Все права защищены{' '}
				<a
					href='https://t.me/alavacya'
					target='_blank'
					rel='noopener noreferrer'
					style={{ color: '#000', textDecoration: 'underline' }}>
					Alavacya
				</a>
				<br />
				©️ {new Date().getFullYear()}.{' '}
				<a
					href='https://t.me/ivankowww'
					target='_blank'
					rel='noopener noreferrer'
					style={{ color: '#000', textDecoration: 'underline' }}>
					Телеграм канал
				</a>
			</p>
		</div>
	)
}

const DescriptionBlock = () => {
	return (
		<section
			style={{
				maxWidth: '600px',
				margin: '0 auto',
				padding: '24px',
				backgroundColor: '#fff',
				borderRadius: '12px',
				boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
			}}>
			<h2
				style={{
					fontSize: '24px',
					fontWeight: '600',
					margin: 0,
					marginBottom: '16px',
					textAlign: 'left',
				}}>
				Узнайте друг друга глубже
			</h2>
			<p
				style={{
					color: '#4a4a4a',
					fontSize: '16px',
					lineHeight: '1.6',
					textAlign: 'left',
				}}>
				Иногда самые простые вопросы могут открыть самые неожиданные стороны личности.
				Приложение предлагает парочкам увлекательный набор вопросов, которые помогают
				раскрыться, поделиться чувствами и взглядами, а также лучше понять друг друга.
				<br />
				<br />
				Вопросы заставляют задуматься о личных эмоциях, мечтах, воспоминаниях и фантазиях,
				превращая обычное общение в игру доверия и искренности. Это идеальный способ сделать
				ваши разговоры более глубокими, живыми и увлекательными — открывайте новые грани
				партнёра и свои собственные вместе!
			</p>
		</section>
	)
}
